import * as React from 'react';

var _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgBusd = function SvgBusd(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_1606_4326)"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#EDF0F4"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F0B90B",
        stroke: "#F0B90B",
        d: "m59.821 20 9.867 10.104-24.844 24.844-9.867-9.866zM74.799 34.978l9.866 10.103-39.821 39.822-9.867-9.866zM29.866 49.955l9.866 10.104-9.866 9.867L20 60.058zM89.777 49.955l9.866 10.104L59.82 99.881l-9.866-9.867z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_1606_4326"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h120v120H0z"
    })))));
};

export { SvgBusd as ReactComponent };
//# sourceMappingURL=BUSD.svg.es.js.map
